export default __webpack_public_path__ + "static/media/holige.58486dee.png";